"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _DarkText = _interopRequireDefault(require("../../../DarkText"));

var _TextButton = _interopRequireDefault(require("../../../Button/DarkButton/TextButton"));

var _styles = require("../common/styles");

var _consts = require("../consts");

var _styles2 = require("./styles");

function HeaderInfo(_ref) {
  var dispatch = _ref.dispatch,
      poll = _ref.poll,
      polls = _ref.polls;
  var singlePoll = polls.length === 1;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(_styles2.pollHeader, _styles.flexAlignCenterStretch, 'poll-header')
  }, _react.default.createElement(_DarkText.default, {
    fontSize: 10,
    color: "iron",
    letterSpacing: 0.5,
    uppercase: true
  }, (0, _format.default)(poll.updatedAt || poll.createdAt, 'Do MMMM, h:mm a')), _react.default.createElement("div", {
    className: (0, _classnames.default)('buttons-wrapper')
  }, poll.status === _consts.PollStatus.DRAFT ? _react.default.createElement(_TextButton.default, {
    className: (0, _classnames.default)('text-buttons', 'delete-poll-button', {
      disabled: singlePoll
    }),
    disabled: singlePoll,
    onClick: function onClick() {
      return dispatch({
        type: _consts.PollTeacherActions.DELETE_POLL_CONFIRMATION,
        payload: {
          pollId: poll.pollId
        }
      });
    }
  }, _react.default.createElement(_DarkText.default, {
    as: "span",
    color: "amethyst",
    fontSize: 14
  }, "Delete poll")) : null, _react.default.createElement(_TextButton.default, {
    className: (0, _classnames.default)('text-buttons'),
    onClick: function onClick() {
      return dispatch({
        type: _consts.PollTeacherActions.CLOSE_POLL_MENU
      });
    }
  }, _react.default.createElement(_DarkText.default, {
    as: "span",
    color: "amethyst",
    fontSize: 14
  }, "Close poll window"))));
}

var _default = HeaderInfo;
exports.default = _default;